import { Dropdown } from "@screencloud/screencloud-ui-components";
import styled from "styled-components";

export const StyledDuplicateDropdownOption = styled(Dropdown)``;
